import { EventEmptyState } from "./EventEmptyState";

export default function EventNotFound() {
  return (
    <EventEmptyState title="Cet événement n'existe pas ou n'est plus disponible" />
  );
}
